import "./LatestSupervisions.html";
import "./LatestSupervisions.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import LatestSupervisionsComponentController from "./LatestSupervisionsComponentController";

export class LatestSupervisionsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = LatestSupervisionsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/LatestSupervisions/LatestSupervisions.html";
    }
}

module("mmManagePortal").component("mmLatestSupervisions", new LatestSupervisionsComponent());
